import { useSyncExternalStore } from 'react'

export const MARKET_DATA_STATUS_EVENT = 'erevis:market-data-status'
let status = null
let connection = null
const failures = new Map()
const listeners = new Set()
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener) }
export const getMarketDataStatus = () => status
export const useMarketDataStatus = () => useSyncExternalStore(subscribe, getMarketDataStatus, () => null)
export function resetMarketDataStatus() {
  status = null
  connection = null
  failures.clear()
  for (const listener of listeners) listener()
}

// Health proves connectivity only. Only matching chart data resolves a chart failure.
export function reportMarketDataStatus(detail) {
  if (typeof window === 'undefined' || !detail) return
  const chart = detail.source === 'chart'
  const key = detail.requestKey
  let recovered = false
  if (chart && key) {
    if (detail.operational) recovered = failures.delete(key)
    else failures.set(key, detail)
  } else {
    connection = detail
  }
  if (failures.size) status = [...failures.values()][0]
  else if (connection?.operational === false) status = connection
  else if (chart) status = { ...detail, recovered }
  else if (!status?.recovered) status = { ...detail, recovered: false,
    ...(detail.operational ? { message: 'IBKR connection is available. Chart history has not been verified by this check.' } : {}) }
  for (const listener of listeners) listener()
  window.dispatchEvent(new CustomEvent(MARKET_DATA_STATUS_EVENT, { detail: status }))
}
